<template>
  <!-- QM §5.10 — shown only when the list actually spans more than one page -->
  <div v-if="meta.total_pages > 1" class="flex items-center gap-2 mt-2">
    <!-- §5.10 — icon-only controls need an accessible name; the glyph alone reads as nothing.
         chevron-left/right are physical, so they swap with the writing direction in RTL. -->
    <woot-button
      size="tiny"
      variant="clear"
      color-scheme="secondary"
      :icon="isRTLView ? 'chevron-right' : 'chevron-left'"
      :aria-label="$t('QUEUES_MGMT.PAGER.PREVIOUS')"
      :is-disabled="isFirstPage"
      @click="$emit('page', meta.current_page - 1)"
    />
    <span class="text-xs text-slate-500">
      {{
        $t('QUEUES_MGMT.PAGER.LABEL', {
          page: meta.current_page,
          totalPages: meta.total_pages,
          total: meta.total_count,
        })
      }}
    </span>
    <woot-button
      size="tiny"
      variant="clear"
      color-scheme="secondary"
      :icon="isRTLView ? 'chevron-left' : 'chevron-right'"
      :aria-label="$t('QUEUES_MGMT.PAGER.NEXT')"
      :is-disabled="isLastPage"
      @click="$emit('page', meta.current_page + 1)"
    />
  </div>
</template>

<script>
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  // QM §5.10 — isRTLView drives the chevron swap, same source the rest of the app uses.
  mixins: [rtlMixin],
  props: {
    meta: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFirstPage() {
      return this.meta.current_page <= 1;
    },
    isLastPage() {
      return this.meta.current_page >= this.meta.total_pages;
    },
  },
};
</script>
